import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Select, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from '../../axiosInstance';
import Profile from '../../components/Profile';
import Notification from '../../components/Notification';
import Input from '../../components/ui/Input';
import { FaSearch } from "react-icons/fa";

const DeleteBookPage = () => {
  const [books, setBooks] = useState([]);
  const [selectedBookId, setSelectedBookId] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const navigate = useNavigate();

  const fetchBooks = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const collegeId = user?.collegeId;
      const res = await axios.get('https://backend.scholarkart.in/api/books/search-college', {
        params: { collegeId, limit: 500 }
      });
      setBooks(res.data.books || []);
    } catch (error) {
      console.error('Error fetching books:', error);
    }
  };

  useEffect(() => {
    fetchBooks();
  }, []);

  const filteredBooks = books.filter((book) => {
    const query = inputValue.toLowerCase();
    return (
      book.bookTitle?.toLowerCase().includes(query) ||
      book.authorName?.toLowerCase().includes(query) ||
      book.publisherName?.toLowerCase().includes(query)
    );
  });

  const handleDelete = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const collegeId = user?.collegeId;
  
      if (!collegeId) {
        console.error('College ID not found');
        return;
      }
  
      await axios.delete(`https://backend.scholarkart.in/api/books/${selectedBookId}`, {
        params: { collegeId }
      });
  
      setConfirmDialogOpen(false);
      navigate('/librarymanagement');
    } catch (err) {
      console.error('Error deleting book:', err);
    }
  };
  

  return (
    <main className="flex-grow p-1">
    <div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">

        <div className="relative w-full max-w-lg">

        </div>

      <div className="flex items-center space-x-4 relative">
        <Notification />
        <Profile />
      </div>
    </div>

      <Box p={4}>
        <Typography variant="h4" mb={4}>Delete Book</Typography>

        <Select
          value={selectedBookId}
          onChange={(e) => setSelectedBookId(e.target.value)}
          fullWidth
          displayEmpty
          sx={{ mb: 2 }}
        >
          <MenuItem value="" disabled>Select a book to delete</MenuItem>
          {filteredBooks.map((book) => (
            <MenuItem key={book._id} value={book._id}>
              {book.bookTitle} - {book.authorName}
            </MenuItem>
          ))}
        </Select>

        <Button
          variant="contained"
          color="error"
          disabled={!selectedBookId}
          onClick={() => setConfirmDialogOpen(true)}
        >
          Delete Selected Book
        </Button>
      </Box>

      {/* Confirm Delete Dialog */}
      <Dialog open={confirmDialogOpen} onClose={() => setConfirmDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this book?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleDelete} color="error" variant="contained">Confirm Delete</Button>
        </DialogActions>
      </Dialog>
    </main>
  );
};

export default DeleteBookPage;
